export const responsive = {
    superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 1024 },
    items: 1,
    slidesToSlide: 1,
    },
    desktop: {
    breakpoint: { max: 1024, min: 800 },
    items: 1,
    },
    tablet: {
    breakpoint: { max: 800, min: 464 },
    items: 1,
    },
    mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    },
};

    export const productData = [
        {
        id: 1,
        description: "https://res.cloudinary.com/dh42zfolc/image/upload/v1679086558/Rectangle_17_i6wpso.png",   
        imageurl:
        "https://res.cloudinary.com/dh42zfolc/image/upload/v1679079592/Mask_Group_gdc5gt.png",
        name: "Edward Newgate",
       price: "Founder Circle",
        text: "“Our dedicated patient engagement app and web portal allow you to access information instantaneously (no tedeous form, long calls, or administrative hassle) and securely”",    
    },
        {
        id: 2,
        description: "https://res.cloudinary.com/dh42zfolc/image/upload/v1679086558/Rectangle_17_i6wpso.png",
        imageurl:
        "https://res.cloudinary.com/dh42zfolc/image/upload/v1679079592/Mask_Group_gdc5gt.png",
        name: "Edward Newgate",
       price: "Founder Circle",
        text: "“Our dedicated patient engagement app and web portal allow you to access information instantaneously (no tedeous form, long calls, or administrative hassle) and securely”",   
    },
            {
        id: 3,
        description: "https://res.cloudinary.com/dh42zfolc/image/upload/v1679086558/Rectangle_17_i6wpso.png",
        imageurl:
        "https://res.cloudinary.com/dh42zfolc/image/upload/v1679079592/Mask_Group_gdc5gt.png",
        name: "Edward Newgate",
       price: "Founder Circle",
        text: "“Our dedicated patient engagement app and web portal allow you to access information instantaneously (no tedeous form, long calls, or administrative hassle) and securely”",
    },
        {
        id: 4,
        description: "https://res.cloudinary.com/dh42zfolc/image/upload/v1679086558/Rectangle_17_i6wpso.png",
        imageurl:
        "https://res.cloudinary.com/dh42zfolc/image/upload/v1679079592/Mask_Group_gdc5gt.png",
        name: "Edward Newgate",
       price: "Founder Circle",
        text: "“Our dedicated patient engagement app  and web portal allow you to access information instantaneously (no tedeous form, long calls, or administrative hassle) and securely”",
    },  
];